/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RetryScheduleRequestBody,
  RetryScheduleRequestBody$Outbound,
  RetryScheduleRequestBody$outboundSchema,
} from "../components/retryschedulerequestbody.js";

export type RetryDeviceIntegrationScheduleSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type RetryDeviceIntegrationScheduleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  retryScheduleRequestBody: RetryScheduleRequestBody;
};

/** @internal */
export type RetryDeviceIntegrationScheduleSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RetryDeviceIntegrationScheduleSecurity$outboundSchema:
  z.ZodMiniType<
    RetryDeviceIntegrationScheduleSecurity$Outbound,
    RetryDeviceIntegrationScheduleSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function retryDeviceIntegrationScheduleSecurityToJSON(
  retryDeviceIntegrationScheduleSecurity:
    RetryDeviceIntegrationScheduleSecurity,
): string {
  return JSON.stringify(
    RetryDeviceIntegrationScheduleSecurity$outboundSchema.parse(
      retryDeviceIntegrationScheduleSecurity,
    ),
  );
}

/** @internal */
export type RetryDeviceIntegrationScheduleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  RetryScheduleRequestBody: RetryScheduleRequestBody$Outbound;
};

/** @internal */
export const RetryDeviceIntegrationScheduleRequest$outboundSchema:
  z.ZodMiniType<
    RetryDeviceIntegrationScheduleRequest$Outbound,
    RetryDeviceIntegrationScheduleRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      retryScheduleRequestBody: RetryScheduleRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        retryScheduleRequestBody: "RetryScheduleRequestBody",
      });
    }),
  );

export function retryDeviceIntegrationScheduleRequestToJSON(
  retryDeviceIntegrationScheduleRequest: RetryDeviceIntegrationScheduleRequest,
): string {
  return JSON.stringify(
    RetryDeviceIntegrationScheduleRequest$outboundSchema.parse(
      retryDeviceIntegrationScheduleRequest,
    ),
  );
}
